module.exports = __webpack_public_path__ + "img/kali.8122ee58.png";